import * as ACTIONS from '../constants/environment';

const initialState = {
  env: '',
  drugId: '',
};

function environment (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.ENVIRONMENT.SET:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.ENVIRONMENT.CLEAR:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}

export default environment;
